import PropTypes from 'prop-types';
import React, {useCallback} from 'react';
import { MenuItem, TextField } from '@mui/material';

const BglSimpleTextFieldSelect = ({name, label, value, itemLabels, itemValues, itemPrefixes, disabledValues, onChange, disabled, ...others}) => {

    const renderValue = useCallback(val => <>{val}</>, []);

    return (
        <TextField
            variant='standard'
            sx={{
                '& .MuiInputBase-input': {
                    textTransform: 'uppercase'
                }
            }}
            select
            name={name}
            label={label}
            value={value}
            onChange={onChange}
            disabled={disabled}
            renderValue={renderValue}
            {...others}
        >

            {itemValues.map((itemValue, key) => (
                <MenuItem
                    key={key+itemValue}
                    value={itemValue}
                    disabled={disabledValues ? disabledValues.includes(key) : false}
                >
                    {itemPrefixes?.[itemValue]}
                    {itemLabels[key]}
                </MenuItem>
            ))}
        </TextField>
    );
};

BglSimpleTextFieldSelect.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.any.isRequired,
    itemLabels: PropTypes.array.isRequired,
    itemValues: PropTypes.array.isRequired,
    itemPrefixes: PropTypes.object,
    disabledValues: PropTypes.array,
    disabled: PropTypes.bool
};

export default BglSimpleTextFieldSelect;
